import { Chip } from "@mui/material";
import { LabelValueForTags } from "components/ui/atoms/LabelValue";
import { getCommons } from "./fieldConverterHelpers";

import { Box, Tooltip } from "@mui/material";

export const ChoiceCell = ({ formattedValue, colDef }) => {
  return (
    <Box
      display="flex"
      justifyContent={colDef.align || "center"}
      alignItems="center"
      height="100%"
    >
      {formattedValue && (
        <Tooltip title={formattedValue.length > 15 ? formattedValue : ""}>
          <Chip
            label={formattedValue}
            size="small"
            style={{
              width: "auto",
              maxWidth: 110,
            }}
          />
        </Tooltip>
      )}
    </Box>
  );
};

export const ChoiceFieldView = ({ field, value }) => {
  if (!field.choices) {
    console.warn(`No choices provided for field ${field.name}`);
  }

  const options =
    field.choices?.filter((option) => option.value === value) || [];

  return (
    <LabelValueForTags
      label={field.label}
      sx={{ display: field.hidden ? "none" : "inherit" }}
      Tags={options.map((option, index) => (
        <Chip key={index} label={`${option.label}`} size="small" />
      ))}
      isMissing={!value}
    />
  );
};

export const choiceFieldConverter = ({ field }) => {
  if (!field.choices) {
    console.warn(`No choices provided for field ${field.name}`);
  }

  return {
    ...getCommons({ field }),
    type: "singleSelect",
    valueOptions: field.choices || [],
    renderCell: ChoiceCell,
    align: field.align || undefined,
  };
};
